import {
  C_BUSINESS_TYPE,
  C_BUSINESS_TYPE_ALL
} from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { C_BUSINESS_DETAILS_ID } from "@/src-refactor/modules/shared/model/const/property/bussines-detail";
import HCheckArray from "@rf-helper/check-have-value";
import { HGetValueFromArray } from "@rf-helper/get-value-from-array";
import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const prepareBudgetToServer = (body: IPropertyForm) => {
  const budget: any = {
    businesstype_id: null,
    price: null,
    currency_id: null,
    alternate_price: null,
    currency_alternate_id: null,
    guaranteed_comission: null,
    total_comission: null,
    lease_commission: null
  };

  const businessTypeMapping = {
    [C_BUSINESS_TYPE.SALE.id]: {
      [C_BUSINESS_DETAILS_ID.NONE]: C_BUSINESS_TYPE_ALL.SALE.id,
      [C_BUSINESS_DETAILS_ID.WHITES]: C_BUSINESS_TYPE_ALL.WHITE_LINE_SALES.id,
      [C_BUSINESS_DETAILS_ID.FURNISHED]: C_BUSINESS_TYPE_ALL.SALE_FURNISHED.id
    },
    [C_BUSINESS_TYPE.SELL.id]: {
      [C_BUSINESS_DETAILS_ID.NONE]: C_BUSINESS_TYPE_ALL.RENT.id,
      [C_BUSINESS_DETAILS_ID.WHITES]: C_BUSINESS_TYPE_ALL.WHITE_LINE_RENTAL.id,
      [C_BUSINESS_DETAILS_ID.FURNISHED]: C_BUSINESS_TYPE_ALL.RENT_FURNISHED.id
    },
    [C_BUSINESS_TYPE.SALE_AND_SELL.id]: {
      [C_BUSINESS_DETAILS_ID.NONE]: C_BUSINESS_TYPE_ALL.SALE_AND_RENT.id,
      [C_BUSINESS_DETAILS_ID.WHITES]:
        C_BUSINESS_TYPE_ALL.SALE_AND_RENTAL_OF_WHITE_GOODS.id,
      [C_BUSINESS_DETAILS_ID.FURNISHED]:
        C_BUSINESS_TYPE_ALL.SALE_AND_FURNISHED_RENTAL.id
    }
  };

  if (
    HCheckArray(body.business_types_property) &&
    body.business_types_property.length > 0
  ) {
    budget.businesstype_id =
      businessTypeMapping[body.business_types_property[0].id as number][
        body.detail_business_property[0].id as number
      ];
  }

  // sale,
  if (
    body.business_types_property[0].id == C_BUSINESS_TYPE.SALE.id &&
    typeof body.price_sale_property == "string"
  ) {
    budget.price = body.price_sale_property;
    budget.currency_id = body.currency_sale_property[0].id;
    budget.guaranteed_comission = body.fee_sale_percentage_commission_property ?? "";
    budget.total_comission = body.fee_sale_selling_agent_commission_percentage ?? "";
  }

  // rent
  if (
    body.business_types_property[0].id == C_BUSINESS_TYPE.SELL.id &&
    typeof body.price_rent_property == "string"
  ) {
    budget.price = body.price_rent_property;
    budget.currency_id = body.currency_rent_property[0].id;
    budget.lease_commission = HGetValueFromArray(body.fee_rent, "value");
  }

  // sale and rent
  if (
    body.business_types_property[0].id == C_BUSINESS_TYPE.SALE_AND_SELL.id &&
    typeof body.price_rent_property == "string" &&
    typeof body.price_sale_property == "string"
  ) {
    budget.price = body.price_sale_property;
    budget.currency_id = body.currency_sale_property[0].id;
    budget.alternate_price = body.price_rent_property;
    budget.currency_alternate_id = body.currency_rent_property[0].id;

    budget.guaranteed_comission = body.fee_sale_percentage_commission_property ?? "";
    budget.total_comission = body.fee_sale_selling_agent_commission_percentage ?? "";
    budget.lease_commission = HGetValueFromArray(body.fee_rent, "value");
  }

  budget.price = budget.price;
  budget.alternate_price = budget.alternate_price;
  return budget;
};

export default prepareBudgetToServer;
